// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close__Urz00","first":"styles_first__1J7rZ","last":"styles_last__2N1SQ"};